var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "article-number",
    class: _vm.containerClass,
    attrs: {
      "title": _vm.value
    },
    on: {
      "dblclick": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d303e118","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ArticleNumber.vue
// module id = 2115
// module chunks = 0